export default class MailTo {
  mailToLinks: NodeListOf<HTMLAnchorElement>;

  constructor() {
    this.mailToLinks = document.querySelectorAll('[data-mail][data-mail-client]');
    if (this.mailToLinks.length) {
      Array.from(this.mailToLinks).forEach(link =>
        link.addEventListener('click', this.handler)
      );
    }
  }

  handler = (e: Event) => {
    const link = e.target as HTMLAnchorElement;
    const mail = link.dataset.mail;
    const mailClient = link.dataset.mailClient;
    if (mail && mailClient) {
      e.preventDefault();
      link.setAttribute('href', `mailto:${mail}@${mailClient}`);
      link.innerText = `${mail}@${mailClient}`;
      delete link.dataset.mail;
      delete link.dataset.mailClient;
    }
  };
}
